import { IEtfBackend } from 'api/etf';
import { transliterate } from 'inflected';

export interface EtfPageParams {
	ticker: string;
}

export enum EtfPageSection {
	INFO = "INFO",
	ASSETS = "ASSETS",
	DOCUMENTS = "DOCUMENTS",
	ANALYSIS_FACTOR = "ANALYSIS_FACTOR",
	CORRELATIONS = "CORRELATIONS",
	ALTERNATIVES = "ALTERNATIVES"
}

export interface EtfPageSectionDefinition {
	section: EtfPageSection;
	iconClass: string;
	title: string;
	hrefFactory: (etf: IEtfBackend) => string;
}

export const EtfPageSectionDefinitions: EtfPageSectionDefinition[] = [
	{ section: EtfPageSection.INFO, iconClass: 'fas fa-home', title: 'Основное', hrefFactory: etf => `/etf/${etf.isin}` },
	{ section: EtfPageSection.ASSETS, iconClass: 'fa fa-database', title: 'Активы', hrefFactory: etf => `/etf/${etf.ticker}/assets` },
	{ section: EtfPageSection.DOCUMENTS, iconClass: 'far fa-file-pdf', title: 'Документы', hrefFactory: etf => `/etf/${etf.ticker}/documents` },
	{ section: EtfPageSection.ANALYSIS_FACTOR, iconClass: 'far fa-file', title: 'Риски и драйверы', hrefFactory: etf => `/etf/${etf.ticker}/analysis/factor` },
	{ section: EtfPageSection.CORRELATIONS, iconClass: 'fas fa-arrows-alt', title: 'Корреляции', hrefFactory: etf => `/etf/${etf.ticker}/correlations` },
	{ section: EtfPageSection.ALTERNATIVES, iconClass: 'fas fa-list-ol', title: 'Альтернативы', hrefFactory: etf => `/screener/?assetClass=${transliterate(etf.tags.investmentPolicy.assetClass)}&region=${transliterate(etf.tags.geography.area)}` }
]